// extracted by mini-css-extract-plugin
export var downArrow = "_9k-0";
export var infoTooltipIcon = "_9k-3";
export var label = "_9k-1";
export var optionCard = "_9k-4";
export var upArrow = "_9k-2";